module.exports = {
  'en': {
    'HRMS74EC1': {
      '10': 'For Memo. No.',
      '20': 'or Course Code',
      '30': 'Year',
      '40': 'Class No.',
      '50': 'Company Code.',
      '80': 'Employee Code',
      '90': 'Name',
      '99': 'Confirm List of Trainee from Dep.',
      '100': 'Position',
      '110': 'Course',
      '120': 'Course Name',
      '130': 'Type of Training',
      '140': 'Qualify (Y/N)',
      '150': 'Status of confirm',
      '160': 'Confirm date',
      '165': 'Confirm By',
      '170': 'Other Details',
      '180': 'Training Qualification',
      '190': 'History of Training',
      '200': 'Training Schedule',
      '210': 'List of Attendants',
      '220': 'จำนวนรายการที่เลือก',
      '230': 'รายการ'
    },
    'HRMS74EC2': {
      '10': 'Trainee"s Qualification',
      '20': 'Year',
      '30': 'Course Code',
      '40': 'No.',
      '50': 'Qualification required',
      '60': 'Condition',
      '70': 'Basic Qualification',
      '80': 'As Specify In Training Course',
      '90': 'New Specification',
      '100': 'For Not Pass Only',
      '110': 'especial that ever train',
      '120': 'Last tr.Date',
      '130': 'As Specify In Training Course',
      '140': 'New Specification'
    },
    'HRMS74EC4': {
      '10': 'Training Schedule',
      '20': 'For Year',
      '30': 'Month',
      '40': 'Class No.',
      '50': 'Course Code',
      '60': 'Course Code',
      '70': 'Course Name',
      '80': 'Month',
      '90': 'Class No.',
      '100': 'Date Start',
      '110': 'Date End',
      '120': 'Instructor/Institute',
      '130': 'Venue'
    },
    'HRMS74EC5': {
      '10': 'Table of Training',
      '20': 'Course Code',
      '30': 'Course Name',
      '40': 'For Year',
      '50': 'Month',
      '60': 'Class No.'
    },
    'HRMS74EC6': {
      '10': 'History of Training Report',
      '20': 'Emp. Code',
      '30': 'Year',
      '40': 'Month',
      '50': 'Class No.',
      '60': 'Course',
      '70': 'Course Name',
      '80': 'Category',
      '90': 'Institute',
      '100': 'Name expert',
      '110': 'Trainnig Date',
      '120': 'Start Date',
      '130': 'End Date',
      '140': 'Training Hrs.',
      '150': 'Position',
      '160': 'Department'
    },
    'HRMS74EC7': {
      '10': 'Detail of Approve',
      '20': 'Approve Name',
      '30': 'Approve Date',
      '40': 'Status',
      '50': 'Approve',
      '60': 'Not Approve',
      '70': 'Remark approve'
    },
    'STDTHISTRN': {
      '10': 'History Of Training',
      '20': 'Employee',
      '30': 'Course Code',
      '40': 'Cours Name',
      '50': 'Year',
      '60': 'Month',
      '70': 'Class NO.',
      '80': 'Type Of',
      '90': 'Training',
      '100': 'Expense',
      '110': 'Score',
      '120': 'Result'
    }
  },
  'th': {
    'HRMS74EC1': {
      '10': 'อ้างถึง Memo. No:',
      '20': 'หรือ หลักสูตร',
      '30': 'ปี',
      '40': 'รุ่นที่',
      '50': 'จากหน่วยงาน',
      '80': 'รหัสพนักงาน',
      '90': 'ชื่อ-นามสกุล',
      '99': 'ยืนยันการส่งพนักงานเข้าอบรม',
      '100': 'ตำแหน่ง',
      '110': 'หลักสูตร',
      '120': 'ชื่อหลักสูตร',
      '130': 'ประเภทการจัดอบรม',
      '140': 'Qualify (Y/N)',
      '150': 'สถานะการยืนยัน',
      '160': 'วันที่ยืนยัน',
      '165': 'ยืนยันโดย',
      '170': 'รายละเอียดเพิ่มเติม',
      '180': 'คุณสมบัติผู้เข้าอบรม',
      '190': 'ประวัติการเข้าอบรมของพนักงาน',
      '200': 'ตารางการจัดอบรม',
      '210': 'รายชื่อผู้เข้าอบรม',
      '220': 'จำนวนรายการที่เลือก',
      '230': 'รายการ'
    },
    'HRMS74EC2': {
      '10': 'คุณสมบัติผู้เข้าอบรม',
      '20': 'ปี',
      '30': 'รหัสหลักสูตร',
      '40': 'ลำดับที่',
      '50': 'คุณสมบัติผู้เข้าอบรม',
      '60': 'เงื่อนไข',
      '70': 'คุณสมบัติตามที่กำหนดในแผนขั้นพื้นฐาน',
      '80': 'คุณสมบัติตามที่กำหนดในหลักสูตร',
      '90': 'เงื่อนไขเพิ่มเติม',
      '100': 'เฉพาะคนที่คะแนนไม่ผ่าน',
      '110': 'เฉพาะคนที่เคยอบรม',
      '120': 'วันที่อบรมล่าสุด',
      '130': 'คุณสมบัติตามที่กำหนดในหลักสูตร',
      '140': 'เงื่อนไขเพิ่มเติม'
    },
    'HRMS74EC4': {
      '10': 'ตารางการจัดอบรม',
      '20': 'สำหรับปี',
      '30': 'เดือน',
      '40': 'รุ่นที่',
      '50': 'รหัสหลักสูตร',
      '60': 'รหัสหลักสูตร',
      '70': 'ชื่อหลักสูตร',
      '80': 'เดือน',
      '90': 'รุ่นที่',
      '100': 'วันที่เริ่มต้น',
      '110': 'วันที่สิ้นสุด',
      '120': 'วิทยากร/สถาบัน',
      '130': 'สถานที่จัดอบรม'
    },
    'HRMS74EC5': {
      '10': 'ตารางการจัดอบรม',
      '20': 'รหัสหลักสูตร',
      '30': 'ชื่อหลักสูตร',
      '40': 'สำหรับปี',
      '50': 'เดือน',
      '60': 'รุ่นที่'
    },
    'HRMS74EC6': {
      '10': 'ประวัติการเข้าอบรมของพนักงาน',
      '20': 'รหัสพนักงาน',
      '30': 'ปี',
      '40': 'เดือน',
      '50': 'รุ่นที่',
      '60': 'รหัสหลักสูตร',
      '70': 'ชื่อหลักสูตร',
      '80': 'ประเภทหลักสูตร',
      '90': 'สถาบัน',
      '100': 'ชื่อวิทยากร',
      '110': 'วันที่อบรม',
      '120': 'วันที่เริ่มต้น',
      '130': 'วันที่สิ้นสุด',
      '140': 'จำนวน ชม.อบรม',
      '150': 'ตำแหน่ง',
      '160': 'หน่วยงาน'
    },
    'HRMS74EC7': {
      '10': 'รายละเอียดการอนุมัติ',
      '20': 'ชื่อผู้ยืนยัน',
      '30': 'วันที่ยืนยัน',
      '40': 'สถานะ',
      '50': 'อนุมัติ',
      '60': 'ไม่อนุมัติ',
      '70': 'หมายเหตุการอนุมัติ'
    },
    'STDTHISTRN': {
      '10': 'ประวัติการฝึกอบรม',
      '20': 'สำหรับพนักงาน',
      '30': 'รหัสหลักสูตร',
      '40': 'ชื่อหลักสูตร',
      '50': 'ปี',
      '60': 'เดือน',
      '70': 'รุ่น',
      '80': 'ประเภท',
      '90': 'อบรม',
      '100': 'ค่าใช้จ่าย',
      '110': 'คะแนนที่ได้',
      '120': 'ผลการประเมิน'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms74e.js